import React from 'react';
import { sendExcessivePaidForm } from './actions';
import Signature from '/react4xp/mixins/ui/button-signature';

type Props = {
    translations: Record<string, string>;
    firstStepResult: {
        excessivePaidXML: string;
        taxpayerCode: string;
    };
};

export const SecondStepForm = (props: Props) => {
    const onSubmit = async (signedRequest: string) => {
        const res = await sendExcessivePaidForm({
            signedRequest,
            taxpayerCode: props.firstStepResult.taxpayerCode,
        });
        console.log(res);
    };

    const onGetXml = async () => {
        return {
            data: props.firstStepResult.excessivePaidXML,
        };
    };

    return (
        <Signature
            onGetXml={onGetXml}
            onSubmit={onSubmit}
            icon={true}
            translations={props.translations}
            signType="SIGN"
        >
            Подписать
        </Signature>
    );
};
